import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';

import PageContent from 'components/core/PageContent';
import useServices from 'services/useServices';
import ProjectPaper from 'components/project/ProjectPaper';
import HorizontallyCentered from 'components/core/HorizontallyCentered';
import H1 from 'components/core/H1';

const Root = styled(PageContent)({});
const SpinnerWrapper = styled(HorizontallyCentered)({
  margin: '1rem 0',
});
const ResultList = styled.ul({
  listStyle: 'none',
  margin: 0,
  padding: 0,
});

export interface ProjectsProps {
  className?: string;
}

function Projects(props: ProjectsProps): React.ReactElement | null {
  const { className } = props;
  const { projectService } = useServices();
  useEffect(() => {
    projectService.search();
  }, [projectService]);
  let body: React.ReactNode = null;
  if (projectService.searchResults) {
    body = (
      <ResultList>
        {projectService.searchResults.map((result) => (
          <ProjectPaper project={result} key={result.id} />
        ))}
      </ResultList>
    );
  } else {
    body = (
      <SpinnerWrapper>
        <CircularProgress />
      </SpinnerWrapper>
    );
  }
  return (
    <Root className={className}>
      <H1>Projects</H1>
      {body}
    </Root>
  );
}

export default observer(Projects);
